import { render, staticRenderFns } from "./SendLoginLink.vue?vue&type=template&id=489e2b46&scoped=true&"
import script from "./SendLoginLink.vue?vue&type=script&lang=js&"
export * from "./SendLoginLink.vue?vue&type=script&lang=js&"
import style0 from "./SendLoginLink.vue?vue&type=style&index=0&id=489e2b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e2b46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
